<bit-card class="[&_bit-form-field:last-of-type]:tw-mb-0">
  <ng-content></ng-content>
</bit-card>
